import PropTypes from "../_util/vue-types";

export default () => ({
  prefixCls: PropTypes.string.def("wf-input"),
  type: PropTypes.oneOf(["text", "phone", "password", "number", "money", "email"]).def("text"),
  disabled: PropTypes.bool,
  name: PropTypes.string,
  value: [String, Number],
  // validationRule: PropTypes.array,
  defaultValue: [String, Number],
  placeholder: [String, Number],
  // clear: PropTypes.bool,
  maxLength: PropTypes.number,
  error: PropTypes.boolean,
  labelnumber: PropTypes.number,
  labelPosition: PropTypes.oneOf(["left", "top"]).def("top"),
  textALigin: PropTypes.oneOf(["left", "center", "right"]).def("left"),
  updatePlaceholder: PropTypes.bool,
  locale: PropTypes.bool,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func
});
